import {
  aDeleteMatchListItem,
  mockDeleteMatchListItemOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const deleteMatchListItemOperationResponse = {
  __typename: 'Mutation' as const,
  deleteMatchListItem: aDeleteMatchListItem(),
};

export const handlers = [
  mockDeleteMatchListItemOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          ...deleteMatchListItemOperationResponse,
        },
      });
    }
  ),
];
